import { useState } from 'react';
import { tickerItems } from '@/mocks/home';

const navLinks = [
  { label: '热度榜', href: '#hot' },
  { label: '最新更新', href: '#feed' },
  { label: '事件脉络', href: '#timeline' },
  { label: '多角度说法', href: '#angles' },
  { label: '话题索引', href: '#topics' },
];

export default function SiteHeader() {
  const [menuOpen, setMenuOpen] = useState(false);
  const loop = [...tickerItems, ...tickerItems];

  return (
    <header className="sticky top-0 z-50">
      <div className="bg-background-50/95 backdrop-blur border-b border-background-200">
        <div className="flex items-center justify-between gap-4 h-16 px-4 md:px-6">
          <a href="#top" className="flex items-center gap-2.5 cursor-pointer shrink-0">
            <span className="w-9 h-9 rounded-md bg-primary-500 flex items-center justify-center">
              <i className="ri-heart-3-fill text-background-50 text-lg"></i>
            </span>
            <h1 className="font-heading text-lg md:text-xl font-bold text-foreground-950 leading-none tracking-tight">
              糖心小桃
            </h1>
          </a>

          <nav className="hidden md:flex items-center gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                className="px-3 py-2 rounded-md text-sm text-foreground-700 hover:text-primary-600 hover:bg-primary-50 transition-colors cursor-pointer whitespace-nowrap"
              >
                {link.label}
              </a>
            ))}
          </nav>

          <div className="flex items-center gap-2">
            <label className="hidden lg:flex items-center gap-2 h-9 px-3 rounded-md bg-background-100 border border-background-200 focus-within:border-primary-300 transition-colors">
              <i className="ri-search-line text-foreground-400 text-base"></i>
              <input
                type="text"
                placeholder="搜索事件 / 关键词"
                className="w-40 xl:w-48 bg-transparent text-sm text-foreground-800 placeholder:text-foreground-400 outline-none"
              />
            </label>
            <a
              href="#subscribe"
              className="hidden sm:inline-flex items-center gap-1.5 h-9 px-4 rounded-md bg-primary-500 text-background-50 text-sm font-medium hover:bg-primary-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <i className="ri-notification-3-line text-base"></i>
              订阅更新
            </a>
            <button
              type="button"
              onClick={() => setMenuOpen((value) => !value)}
              className="md:hidden w-9 h-9 rounded-md border border-background-200 bg-background-100 flex items-center justify-center text-foreground-700 cursor-pointer"
              aria-label="打开菜单"
            >
              <i className={menuOpen ? 'ri-close-line text-xl' : 'ri-menu-line text-xl'}></i>
            </button>
          </div>
        </div>
      </div>

      {menuOpen && (
        <nav className="md:hidden bg-background-50 border-b border-background-200 px-4 py-3 flex flex-col gap-1">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              onClick={() => setMenuOpen(false)}
              className="px-3 py-2.5 rounded-md text-sm text-foreground-700 hover:bg-primary-50 hover:text-primary-600 cursor-pointer"
            >
              {link.label}
            </a>
          ))}
        </nav>
      )}

      <div className="bg-primary-500 text-background-50">
        <div className="flex items-center h-9 px-4 md:px-6 gap-3">
          <span className="flex items-center gap-1.5 shrink-0 whitespace-nowrap text-xs font-label font-medium">
            <span className="w-1.5 h-1.5 rounded-full bg-background-50 animate-softPulse"></span>
            实时更新
          </span>
          <span className="w-px h-4 bg-background-50/40 shrink-0"></span>
          <div className="relative overflow-hidden flex-1">
            <div className="flex w-max animate-ticker">
              {loop.map((text, index) => (
                <span key={index} className="flex items-center gap-2 pr-8 text-xs whitespace-nowrap">
                  <i className="ri-arrow-right-s-line"></i>
                  {text}
                </span>
              ))}
            </div>
          </div>
        </div>
      </div>
    </header>
  );
}